import React, { useState, useEffect } from 'react';
import { useTickContext } from "../../../contexts/TickContext";
import {useStateUpdatePermission} from "../../../contexts/StateUpdateContext";
import {useQuoteContext} from "../../../contexts/QuoteContext";

const PriceDifferenceDisplay = React.memo(({ instrumentToken, setPriceColor, setLastPriceColor, contextName  }) => {
    const [priceDifferencePercentage, setPriceDifferencePercentage] = useState(null);
    const { canUpdateState } = useStateUpdatePermission(); // Access the permission state
    const tickContext = useTickContext();
    const quoteContext = useQuoteContext();
    const [colour,setColour] = useState('#000000');

    const contextData = (() => {
        switch (contextName) {
            case 'TickContext':
                return tickContext;
            case 'QuoteContext':
                return quoteContext;
            default:
                throw new Error(`Unknown context: ${contextName}`);
        }
    })();
    const tick = contextData.tick;

    // Fetch and calculate price difference
    useEffect(() => {
        if (canUpdateState) {
            if (tick.lastTradedPrice && tick.closePrice) {
                const percentageDifference = ((tick.lastTradedPrice - tick.closePrice) / tick.closePrice) * 100;
                if (canUpdateState) {
                    setPriceDifferencePercentage(percentageDifference.toFixed(2));
                } // Limit to 2 decimal places

                // Determine color based on price difference

                if (tick.lastTradedPrice > tick.closePrice) {
                    setColour('#33A533');
                    setPriceColor('#33A533'); // Set green for upward trend
                    setLastPriceColor('#33A533'); // Set green for last-traded-price
                }  else if(tick.lastTradedPrice < tick.closePrice){
                    setColour('#FF6666');
                    setPriceColor('#FF6666'); // Set red for downward trend
                    setLastPriceColor('#FF6666'); // Set red for last-traded-price
                }else{
                    setColour('#070707');
                    setPriceColor('#070707'); // Set red for downward trend
                    setLastPriceColor('#070707'); // Set red for last-traded-price
                }
            }
        }
    }, [tick.lastTradedPrice]);

    return (
        <div className="mw-price-difference"  style={{ color: colour }}>
            <span>
    {priceDifferencePercentage !== null
        ? (priceDifferencePercentage < 0
            ? <span className="negative">-</span>
            : null)
        : null} {/* Conditionally display the negative sign */}
                {priceDifferencePercentage !== null ? `${Math.abs(priceDifferencePercentage)}%` : '0.00%'}
            </span>
        </div>
    );
});

export default PriceDifferenceDisplay;
